import {EFormJobTimeRule, EJobPriority} from 'src/app/models'

export const formFilterJob = {
  priority: [],
  progresses: [],
  company_ids: [],
  department_ids: [],
  agent_ids: [],
  template_ids: [],
  status: undefined,
  start_date: undefined,
  end_date: undefined,
  cursor: undefined
}

export const formValuesJob = {
  // informasi job
  company_id: '',
  company_label: '',
  department_id: '',
  department_label: '',
  name: '',
  priority: '' as keyof typeof EJobPriority,
  wo_number: '',
  description: '',
  address: '',
  location: '',
  location_name: '',
  job_type: 'SINGLE',

  // informasi jadwal
  time_rule: 'FIXED' as keyof typeof EFormJobTimeRule,
  start_date: '' as any,
  end_date: '' as any,
  start_time: '' as any,
  end_time: '' as any,
  is_recurring: false,
  recurring_interval: 1,
  recurring_unit: undefined,
  recurring_end: 'DATE' as 'DATE' | 'COUNT',
  recurring_end_date: '',
  recurring_end_count: 0,

  recurring_custom_interval: 1,
  recurring_custom_unit: 'DAY',
  recurring_custom_days: [],

  // informasi agen
  pic_agent: [],
  has_attendance: false,
  radius: '',
  is_selfie: false,

  // verifikasi job
  approval: false,
  approval_by: '',
  approval_by_label: '',
}

export const formUploadJob = {
  upload: undefined as File | undefined,
  upload_preview: [] as Array<any>,
  bulk_form: [],
  checked_rows: [] as number[],
  upload_session: undefined,
}
